import React, { useState } from "react";
import logo from "../assets/logo.svg";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "./navbar.css";

const Navbar = () => {
  const navLinks = [
    { name: "Login", href: "/log-in" },
    { name: "Register", href: "/registration" },
  ];

  const addmembersLinks = [
    { name: "Dashboard", href: "/" },
    { name: "LogOut", href: "/log-in" },
  ];

  const [showSidebar, setShowSidebar] = useState(false); // State for sidebar visibility

  const location = useLocation();
  const navigate = useNavigate();

  const isActiveLink = (link) => link === location.pathname;

  const toggleSidebar = () => setShowSidebar(!showSidebar); // Function to toggle sidebar

  return (
    <div>
      {/* Header Section */}
      <div className="header p-2 d-flex align-items-center justify-content-between">
        <img
          src={logo}
          alt="logo"
          style={{ height: "45px", cursor: "pointer" }}
          onClick={() => navigate("/")}
        />

        <div className="d-none d-sm-flex gap-3">
          {location.pathname === "/" && (
            <button
              style={{
                backgroundColor: "white",
                color: "#034da2",
                fontSize: "1.2rem",
                transition: "background-color 0.3s ease, color 0.3s ease",
              }}
              className="btn btn-light  rounded-3 fw-bold d-flex align-items-center gap-2"
              onClick={() => {
                localStorage.removeItem("aimsToken");
                navigate("/log-in");
              }}
            >
              Logout
            </button>
          )}

          {location.pathname !== "/add-members" &&
            location.pathname !== "/" && (
              <>
                {navLinks.map((link) => {
                  const isActive = location.pathname === link.href;
                  return (
                    <Link
                      key={link.name}
                      to={link.href}
                      style={{ textDecoration: "none" }}
                    >
                      <div
                        style={{
                          backgroundColor: isActive ? "white" : "#034da2",
                          color: isActive ? "#034da2" : "white",
                          fontSize: "1.2rem",
                          transition:
                            "background-color 0.3s ease, color 0.3s ease",
                        }}
                        className="btn btn-light rounded-3 fw-bold d-flex align-items-center gap-2"
                      >
                        {link.name}
                      </div>
                    </Link>
                  );
                })}
              </>
            )}

          {location.pathname === "/add-members" && (
            <>
              {addmembersLinks.map((link) => {
                const isActive = location.pathname === link.href;
                return (
                  <Link
                    key={link.name}
                    to={link.href}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      style={{
                        backgroundColor: "white",
                        color: "#034da2",
                        fontSize: "1.2rem",
                        transition:
                          "background-color 0.3s ease, color 0.3s ease",
                      }}
                      className="btn btn-light  rounded-3 fw-bold d-flex align-items-center gap-2"
                      onClick={() => {
                        if (link.name === "LogOut") {
                          localStorage.removeItem("aimsToken");
                          navigate("/log-in");
                        }
                      }}
                    >
                      {link.name}
                    </div>
                  </Link>
                );
              })}
            </>
          )}
        </div>

        {/* SVG for Hamburger Menu */}
        <div className="d-block d-sm-none" onClick={toggleSidebar}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="white"
            className="bi bi-list"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
            />
          </svg>
        </div>
      </div>
      {showSidebar && (
        <div
          className="overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 1,
            cursor: "pointer",
          }}
          onClick={toggleSidebar} // Close sidebar when clicking on the overlay
        ></div>
      )}

      {/* Sidebar Section */}
      <div
        className={`sidebar  ${
          showSidebar ? "sidebar-open" : "sidebar-closed"
        }`}
      >
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-light rounded-3"
            style={{
              marginTop: "20px",
              backgroundColor: "transparent",
              border: "none",
            }}
            onClick={toggleSidebar}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              fill="white"
              className="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
          </button>
        </div>
        <div className="sidebar-links">
          {location.pathname === "/" && (
            <button
              style={{
                backgroundColor: "white",
                color: "#034da2",
                fontSize: "1.2rem",
                transition: "background-color 0.3s ease, color 0.3s ease",
              }}
              className="btn btn-light  rounded-3 fw-bold d-flex align-items-center gap-2"
              onClick={() => {
                localStorage.removeItem("aimsToken");
                navigate("/log-in");
                toggleSidebar(); // Close sidebar after clicking a link
              }}
            >
              Logout
            </button>
          )}

          {location.pathname !== "/add-members" &&
            location.pathname !== "/" && (
              <>
                {navLinks.map((link) => {
                  const isActive = location.pathname === link.href;
                  return (
                    <Link
                      key={link.name}
                      to={link.href}
                      style={{ textDecoration: "none" }}
                    >
                      <div
                        style={{
                          backgroundColor: isActive ? "white" : "#034da2",
                          color: isActive ? "#034da2" : "white",
                          fontSize: "1.2rem",
                          transition:
                            "background-color 0.3s ease, color 0.3s ease",
                        }}
                        className="btn btn-light   rounded-3 fw-bold d-flex align-items-center gap-2"
                        onClick={toggleSidebar}
                      >
                        {link.name}
                      </div>
                    </Link>
                  );
                })}
              </>
            )}

          {location.pathname === "/add-members" && (
            <>
              {addmembersLinks.map((link) => {
                const isActive = location.pathname === link.href;
                return (
                  <Link
                    key={link.name}
                    to={link.href}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      style={{
                        backgroundColor: "white",
                        color: "#034da2",
                        fontSize: "1.2rem",
                        transition:
                          "background-color 0.3s ease, color 0.3s ease",
                      }}
                      className="btn btn-light rounded-3 fw-bold d-flex align-items-center gap-2"
                      onClick={() => {
                        if (link.name === "LogOut") {
                          localStorage.removeItem("aimsToken");
                          navigate("/log-in");
                        }
                        toggleSidebar(); // Close sidebar after clicking a link
                      }}
                    >
                      {link.name}
                    </div>
                  </Link>
                );
              })}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;

{
  //  {!isActiveLink("/log-in") && (
  //       <button
  //         style={{
  //           backgroundColor: "white",
  //           color: " #034da2",
  //           fontSize: "1.2rem",
  //         }}
  //         class="btn btn-light fw-bold rounded-5 d-flex align-items-center gap-2"
  //         onClick={() => {
  //           localStorage.removeItem("aimsAdminToken");
  //           navigate("/log-in");
  //         }}
  //       >
  //         Log-Out
  //       </button>
  //     )}
}
